import { render, staticRenderFns } from "./lawsuit_info.vue?vue&type=template&id=7b22fe34&scoped=true"
import script from "./lawsuit_info.vue?vue&type=script&lang=js"
export * from "./lawsuit_info.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_info.vue?vue&type=style&index=0&id=7b22fe34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b22fe34",
  null
  
)

export default component.exports